<!--
 * @Author: your name
 * @Date: 2021-07-06 14:06:06
 * @LastEditTime: 2021-07-08 10:38:50
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \erp-web\src\components\radio\gj-radio-group.vue
-->
<template>
  <el-radio-group
      v-bind="$attrs"
      v-on="$listeners"
      :size="mapSize"
      :value="value"
      class="gj-radio-group"
      :class="{'gj-ghost': type === 'default'}"
      @input="change">
    <el-radio-button
        v-for="item in options"
        :label="item.id"
        :key="item.id">
      {{item.text}}
    </el-radio-button>
  </el-radio-group>
</template>

<script>
  import {sizeMap} from "../common";

  export default {
    name: "gj-radio-group",
    props: {
      value: null,
      options: {
        type: Array,
        default: () => []
      },
      size: {
        type: String,
        default: 'default',
        validator: function (value) {
          return ['default', 'mini'].indexOf(value) !== -1
        }
      },
      type: {
        type: String,
        default: 'default',
        validator: function (value) {
          return ['default', 'primary'].indexOf(value) !== -1
        }
      },
      // radio改变是否缓存 
      isUseCache: {
        type: Boolean,
        default: false
      },
      // 自定义缓存key
      customCacheKey: {
        type: String,
        default: ''
      }
    },
    computed: {
      mapSize() {
        return sizeMap[this.size];
      }
    },
    watch: {
      value(val) {
        
      }
    },
    methods: {
      change(val) {
        if (this.isUseCache) {
          this.$cacheTab.setCache({params: { val }, key: this.customCacheKey})
        }
        this.$emit('input', val)
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import "../../element-variables";
  
  .gj-ghost /deep/ .el-radio-button__orig-radio:checked + .el-radio-button__inner {
    background: #fff;
    color: $--color-primary;
  }
  .gj-ghost{
    .el-radio-button__inner{
      border-color: #D8DADD;
      color: #666666;
    }
    & /deep/ .is-active{
      .el-radio-button__inner {
        //font-weight: bold;
        background: $gj-active-bg !important;
      }
    }
  }
  /deep/ .el-radio-button--small .el-radio-button__inner{
    font-size: 13px;
  }
</style>
